import OrganizationLocationNew from 'src/components/Organization/pages/locations/new';

export default OrganizationLocationNew;
